import * as React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';


import App from './App';
import theme from './theme';
import './i18n';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <HelmetProvider>
      <BrowserRouter>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </ThemeProvider>,
  document.querySelector('#root'),
);
